// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "./PaymentMethodsRecord.bs.js";

function buildFromPaymentListV2(pList, localeString) {
  var paymentMethodArr = pList.paymentMethodsEnabled;
  return paymentMethodArr.map(function (paymentMethodObject) {
              var methodType = paymentMethodObject.paymentMethodType;
              var handleUserError = methodType === "wallet";
              var paymentMethodName = paymentMethodObject.paymentMethodSubtype;
              var bankNamesList = Core__Option.getOr(paymentMethodObject.bankNames, []);
              return {
                      paymentMethodName: paymentMethodName,
                      fields: PaymentMethodsRecord$OrcaPaymentPage.getPaymentMethodFields(paymentMethodName, paymentMethodObject.requiredFields, localeString, undefined, undefined),
                      paymentFlow: [],
                      handleUserError: handleUserError,
                      methodType: methodType,
                      bankNames: bankNamesList
                    };
            });
}

function getPaymentExperienceTypeFromPML(paymentMethodList, paymentMethodName, paymentMethodType) {
  return Core__Array.reduce(paymentMethodList.paymentMethodsEnabled, [], (function (acc, ele) {
                if (ele.paymentMethodType === paymentMethodName && ele.paymentMethodSubtype === paymentMethodType) {
                  return Belt_Array.concatMany([
                              acc,
                              Core__Option.getOr(ele.paymentExperience, [])
                            ]);
                } else {
                  return acc;
                }
              }));
}

export {
  buildFromPaymentListV2 ,
  getPaymentExperienceTypeFromPML ,
}
/* PaymentMethodsRecord-OrcaPaymentPage Not a pure module */
